import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  IonLabel,
  IonText,
  IonRow,
  IonCol
} from '@ionic/react';
import { Card } from '@tremor/react';

const SmsPlans = ({
  smsAmount,
  onSmsAmountChange,
  errors
}) => {
  const [isDarkTheme, setIsDarkTheme] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    setIsDarkTheme(mediaQuery.matches);

    const handler = (e) => setIsDarkTheme(e.matches);
    mediaQuery.addEventListener('change', handler);
    return () => mediaQuery.removeEventListener('change', handler);
  }, []);

  const isActive = !!smsAmount;

  const getBorderColor = () => {
    return isDarkTheme ? '#f4f5f8' : '#3880ff'; // dark: light border, light: Ionic blue
  };

  return (
    <IonRow>
      <IonCol size="12">
        <Card
          className="ion-margin"
          style={{
            border: `2px solid ${isActive ? getBorderColor() : 'transparent'}`,
            boxShadow: isActive ? '0 0 0 3px rgba(56, 128, 255, 0.4)' : 'none',
            borderRadius: '10px',
            padding: '1rem',
            transition: 'box-shadow 0.3s ease, border-color 0.3s ease',
          }}
        >
          <IonText>
            <p className="ion-margin-bottom">
              Enter SMS amount you wish to purchase. 1 SMS is equal to 1 KES
            </p>
          </IonText>

          <div className="ion-margin-bottom">
            <IonLabel htmlFor="smsAmount" className="ion-margin-bottom">SMS Amount</IonLabel>
            <input
              type="number"
              id="smsAmount"
              name="smsAmount"
              value={smsAmount || ''}
              onChange={onSmsAmountChange}
              placeholder="Enter SMS amount"
              className="form-control"
              style={{
                width: '100%',
                padding: '10px',
                fontSize: '16px',
                borderRadius: '8px',
                border: '1px solid #ccc',
                backgroundColor: isDarkTheme ? '#1e1e1e' : '#fff',
                color: isDarkTheme ? '#fff' : '#000'
              }}
            />
          </div>

          {errors.smsAmount && (
            <IonText color="danger">
              <small>{errors.smsAmount}</small>
            </IonText>
          )}
        </Card>
      </IonCol>
    </IonRow>
  );
};

SmsPlans.propTypes = {
  smsAmount: PropTypes.string.isRequired,
  onSmsAmountChange: PropTypes.func.isRequired,
  errors: PropTypes.shape({
    smsAmount: PropTypes.string
  }).isRequired
};

export default SmsPlans;
